import { writable } from "svelte/store";
export default class Controller {
    constructor(words) {
        this.words = words;
        this.currentIndex = -1;
        this.wpmHistory = [];
        this.totalWords = 0;
        this.state = State.READY;
        this.store = writable(this);
        this.subscribe = this.store.subscribe;
        window.addEventListener("keydown", (event) => {
            if (event.code == "Space")
                this.onPlayerInput();
        });
    }
    onPlayerInput() {
        switch (this.state) {
            case State.READY:
                this.state = State.IN_PROGRESS;
                this.onStart();
                this.onPlayerInput();
                break;
            case State.IN_PROGRESS:
                this.onLineEnd();
                if (this.currentIndex < this.words.length - 1) {
                    this.currentIndex++;
                }
                else {
                    this.state = State.FINISHED;
                    this.onFinish();
                }
                break;
            case State.FINISHED:
                break;
        }
        this.store.set(this);
    }
    onStart() {
        this.startTimestamp = Date.now();
    }
    onLineEnd() {
        let now = Date.now();
        if (this.lastLineTimestamp) {
            let diff = now - this.lastLineTimestamp;
            let words = this.currentLine.split(" ").length;
            this.totalWords += words;
            let wpm = words / (diff / 1000 / 60);
            this.wpmHistory.push(wpm);
        }
        this.lastLineTimestamp = now;
    }
    onFinish() {
        this.finishTimestamp = Date.now();
    }
    get prevLine() {
        return this.words[this.currentIndex - 1];
    }
    get currentLine() {
        return this.words[this.currentIndex];
    }
    get nextLine() {
        return this.words[this.currentIndex + 1];
    }
    get lastWpm() {
        return this.wpmHistory[this.wpmHistory.length - 1];
    }
    get totalWpm() {
        var _a;
        let wpm = this.totalWords / (((_a = this.finishTimestamp) !== null && _a !== void 0 ? _a : Date.now()) - this.startTimestamp) * 1000 * 60;
        return Number.isNaN(wpm) ? undefined : wpm;
    }
}
export var State;
(function (State) {
    State[State["READY"] = 0] = "READY";
    State[State["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    State[State["FINISHED"] = 2] = "FINISHED";
})(State || (State = {}));
